import { DCarbonizeAppConfig } from 'app/@types/shared/app-config';

export const environment: DCarbonizeAppConfig = {
    apiUrl: 'https://scan-test.carbon-cockpit.eu/api',
    appVersion: require('../../package.json').version + '-test',
    client: {
        clientConfig: false,
        colors: [
            '#4BAAF5',
            '#6EBE71',
            '#FCCC55',
            '#FF6259',
            '#6372C3',
            '#F79530',
            '#30AA9F',
            '#30C9DC',
            '#AF50BF',
            '#7E96A1',
        ],
        font: 'Poppins',
        mainColor: '#2E6BF3',
        name: 'Dcarbonize',
        support: {
            mailDcarbonize: 'scan@d-carbonize.eu',
        },
    },
    cognitoAppClientId: '4o326cjj7277etm92f9qekoukp',
    cognitoRegion: 'eu-west-3',
    cognitoUserPoolId: 'eu-west-3_t2hhmWWyK',
    cookieStorage: {
        domain: 'scan-test.carbon-cockpit.eu',
        expires: 31,
        path: '/',
        sameSite: 'strict',
        secure: true,
    },
    debug: {
        tracing: false,
    },
    defaultLocale: 'en',
    domain: 'scan-test.carbon-cockpit.eu',
    googleTagManager: {
        id: 'GTM-NRDLG6X',
    },
    hmr: false,
    oauth: {
        domain: '',
        redirectSignIn: 'https://scan-test.carbon-cockpit.eu/auth/login',
        redirectSignOut: 'https://scan-test.carbon-cockpit.eu/auth/logout',
        scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    },
    production: false,
    registerAllowed: true,
    showVideoOnboarding: true,
    chatHiveAPI: 'BCf_YulXJLVM9SMbtMbb_NYw',
    isChatbotShown: true,
    supportedLanguages: ['en', 'fr', 'nl'],
};
